<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <div disabled>
        <a-steps v-model:current="current" type="navigation" size="small" :style="{
            marginBottom: '60px',
            boxShadow: '0px -1px 0 0 #e8e8e8 inset',
          }">
          <!-- <a-step status="finish" disabled title="选择商品类目" /> -->
          <a-step status="finish" disabled title="编辑基本信息" />
          <a-step status="finish" disabled title="编辑图文详情" />
        </a-steps>
      </div>
      <a-form ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <!-- <div class="content p-t-50 width90 s_mauto" v-show="current == 0" :disabled="$route.query.type == 'look'">
          <a-form-item ref="product_category_type_id" label="产品类目" hidden name="product_category_type_id">
            <a-input v-model:value="form.product_category_type_id" placeholder="请输入产品名称" />
          </a-form-item>
          <a-spin :spinning="typeLoading">
            <div v-if="CategoryList.length==0" class='p-b-50'>
              <a-empty description='暂无商品类目'/>
            </div>
            <div class="clearfix">
              <template v-for="(v, k) in CategoryList" :key="k">
                <div class="cateItem m-b-47 fl" v-if="k < 7">
                  <input type="radio" hidden v-model="form.product_category_type_id" :id="v.id" :value="v.id" :checked="form.product_category_type_id==v.id" />
                  <label :for="v.id">
                    {{ v.title }}
                    <div class="current"><span>√</span></div>
                  </label>
                </div>
              </template>
              <div class="otherItem cateItem m-b-47 fl" v-if="CategoryList.length >= 8">
                <span class="fz-15">其它</span>&nbsp;&nbsp;&nbsp;
                <DownOutlined />
                <div class="otherList">
                  <div class="white-line"></div>
                  <a-radio-group v-model:value="form.product_category_type_id">
                    <template v-for="(v, k) in CategoryList" :key="k">
                      <a-radio :value="v.id" v-if="k >= 7">
                        {{ v.title }}
                      </a-radio>
                    </template>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <a-form-item  v-if="CategoryList.length>0">
              <a-button type="primary" @click="next(1)"> 下一步 </a-button>
            </a-form-item>
            
          </a-spin>
        </div> -->
        <div class="content " v-show="current == 0">
          <SmallSquare class="m-b-25" content="产品基本信息" />
          <a-form-item ref="product_name" label="产品名称" name="product_name" :rules="[{ required: true, message: '请输入产品名称' }]">
            <a-input v-model:value="form.product_name" placeholder="请输入产品名称" />
          </a-form-item>
          <!-- <a-form-item ref="product_category_type_id" label="产品类目" name="product_category_type_id" :rules="[{ required: true, message: '请输入产品类目' }]">
            <a-select v-model:value="form.product_category_type_id" :mode="mode" placeholder="请选择商品类目">
              <a-select-option :key='item.id' :value="item.id" v-for='item in CategoryList'>
                {{item.title}}
              </a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item ref="image_url" label="产品图片" name="image_url" :rules="[{ required: true, message: '请添加产品图片' }]" help="图片宽高要求1:1比例，建议尺寸为640px*640px以上；最多上传5张图片。">
            <material :groupType="1" :imageList="form.image_url" :max="5" v-on:handlechoose="(data) => {form.image_url.push(...data);}
              " v-on:handledel="(data) => {form.image_url = data;}" />
          </a-form-item>
          <a-form-item label="产品视频" :rules="[{ required: true, message: '请选择是否要视频' }]" name="video_is_show">
            <a-radio-group v-model:value="form.video_is_show">
              <a-radio :value="1">显示</a-radio>
              <a-radio :value="0">不显示</a-radio>
            </a-radio-group>
            <a-form-item label="视频" v-if="form.video_is_show==1" :label-col="{span:3}">
               <material  :groupType='2' :image="form.video_cover_image_url" :max="1" v-on:handlechoose="(data)=>{
                    form.video_url=data.file_name;form.video_cover_image_url=data.video_image_name}" v-on:handledel="form.video_url='';form.video_cover_image_url=''" />
            </a-form-item>
                    <a-form-item label="视频封面" v-if="form.video_is_show==1" :label-col="{span:3}" help="用于商品详情页显示,图片宽高要求1:1比例,建议尺寸为640px*640px
                    以上,最多上传一张">
               <material  :groupType='1' :image="form.video_image_url" :max="1" v-on:handlechoose="(data)=>{
                    form.video_image_url=data}" v-on:handledel="form.video_image_url=''" />
            </a-form-item>
          </a-form-item>

          <a-form-item ref="product_category_id" label="产品分类" name="product_category_id" :rules="[{ required: true, message: '请输入产品分类' }]">
            <a-row type="flex">
              <a-col span="20">
                <a-cascader v-model:value="form.product_category_id" :options="cateList" placeholder="产品分类" :field-names="{
                label: 'group_name',
                value: 'id',
                children: 'child',
              }" />
              </a-col>
              <a-col span="2">
                <a-button type="link" @click="$router.push('/product/libs/cate/index')">产品分类</a-button>
              </a-col>
            </a-row>
          </a-form-item>

          <a-form-item ref="product_weight" label="产品重量" name="product_weight" v-if="!spec_type" :rules="[{ required: true, message: '请输入产品重量' }]">
            <a-input v-model:value="form.product_weight" placeholder="产品重量" suffix="kg" />
          </a-form-item>
          <a-form-item ref="unit" label="产品单位" name="unit" help="(例:件)">
            <a-input v-model:value="form.unit" placeholder="请输入产品单位" />
          </a-form-item>
          <a-form-item ref="bar_code" label="产品条码" name="bar_code" help="(13位商品条码)">
            <a-input v-model:value="form.bar_code" placeholder="请输入产品条码" />
          </a-form-item>

          <a-form-item ref="parameter" label="产品参数" name="parameter">
            <div style="background: #ececec; padding: 30px 15px">
              最多50个
              <a-card title="" :bordered="false">
                <p class="m-b-20 s_flex_bian_c" v-for="(v, k) in form.parameter" :key="k">
                  <span>
                    {{ v[0] + "/" + v[1] }}
                  </span>
                  <a href="javascript:;">
                    <DeleteOutlined @click="() => form.parameter.splice(k, 1)" />
                  </a>
                </p>
                <a-input-group size="large">
                  <a-row>
                    <a-col :span="5">
                      <a-input v-model:value="parameterKey" placeholder="如:成分" />
                    </a-col>
                    <a-col :span="18" :offset="1">
                      <a-input-search v-model:value="parameterValue" enter-button="添加" size="large" @search="onParameterCreate" />
                    </a-col>
                  </a-row>
                </a-input-group>
              </a-card>
            </div>
          </a-form-item>
          <!-- <a-form-item ref="breif" label="产品描述" name="breif" :help="form.breif?form.breif.length+'/100（限100字内，产品描述将显示在产品码的推送信息上）':0+''+'/100（限100字内，产品描述将显示在产品码的推送信息上）'">
            <a-textarea v-model:value="form.breif" placeholder="请输入产品描述" :maxlength="100" :auto-size="{ minRows: 2, maxRows: 5 }" />
          </a-form-item> -->
          <SmallSquare class="m-b-20" content="产品描述信息" />
          <!-- <a-form-item ref="name" label="云店商城" name="name" :rules="[{ required: true, message: '请输入云店商城' }]">
            <a-input v-model:value="form.name" placeholder="请输入云店商城" />
          </a-form-item> -->
          <!--产品规格-->
          <a-form-item ref="spec_many" label="产品规格" name="spec_many" :wrapper-col="{ span: 20}">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="spec_type" checked-children="多" un-checked-children="单" :disabled="$route.query.type == 'edit'" @change="changeSkuType" />
            <template v-if="spec_type">
              <a-form-item v-for="(v, k) in skus" :key="k" v-bind="index === 0 ? formItemLayout : {}">
                <div class="parameterItem" v-if="skus.length">
                  <a-input v-model:value="v.spec_name" placeholder="规格名" style="width: 80px; margin-right: 8px" :disabled="$route.query.type == 'edit'" />
                  <template v-for="(value,key) in v.spec_value" :key="key">
                    <a-input placeholder="规格值" style="width:80px;margin-right: 8px" :value="value.name" v-model:value="value.name" :disabled="$route.query.type == 'edit'" />
                    <MinusCircleOutlined class="dynamic-delete-button m-r-10" @click="removeskuvalue(k,key)" v-if="$route.query.type != 'edit'" />
                  </template>
                  <a-input v-model:value="v.value" :disabled="$route.query.type == 'edit'" placeholder="追加规格值" @blur="addSku(k)" style="width:200px;" v-if="skus.length" />
                  <a-button @click="addSku(k)" class='m-l-10' :disabled="$route.query.type == 'edit'"> 添加 </a-button>
                  <MinusCircleOutlined class="dynamic-delete-button m-l-10" @click="removesku(k)" v-if="$route.query.type != 'edit'" />
                </div>
              </a-form-item>
              <a-form-item v-if="$route.query.type != 'edit'">
                <a-button type="dashed" @click="addParameter" class='m-r-20'>
                  <PlusOutlined /> 追加规格
                </a-button>
                <a-button type="dashed" @click="cretateSpace(false)">
                  <PlusOutlined /> 生成规格
                </a-button>
              </a-form-item>
              <a-table bordered :data-source="specGridCell" :columns="columns" :pagination='false'>
                <template #name="{ record }">
                  <p class="width-50"><span v-for="(v,k) in record.propertyList" :key='k'>{{v.value}}{{record.propertyList[k+1]?'__':''}}</span></p>
                </template>
                <template #imageUrl="{ record }">
                  <div class='ant-upload-list ant-upload-list-picture-card' v-if='$route.query.type == "edit"'>
                    <div class='ant-upload-list-picture-card-container'>
                      <span>
                        <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                          <div class="ant-upload-list-item-info">
                            <img :src="info.picdomain+'/'+record.image_url" class='ant-upload-list-item-image' />
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                  <material v-if='$route.query.type != "edit"' :image="record.image_url" :groupType='1' :max="1" v-on:handlechoose="(data)=>{record.image_url=data}" v-on:handledel="(data)=>record.image_url=''" />
                </template>
                <template #productSales="{ record }">
                  <a-input-number placeholder="销量" :value="record.product_sales" v-model:value="record.product_sales" :disabled="$route.query.type == 'edit'" />
                </template>
                <!-- <template #marketPrice="{ record }">
                  <a-input-number placeholder="市场价" :value="record.market_price" v-model:value="record.market_price" />
                </template> -->

                <template #productPrice="{ record }">
                  <a-input-number placeholder="产品价格" :value="record.product_price" v-model:value="record.product_price" v-inputFilter:price :disabled="$route.query.type == 'edit'" />
                </template>
                <!-- <template #productWeight="{ record }">
                  <a-input-number placeholder="产品重量" :value="record.product_weight" v-model:value="record.product_weight" />
                </template> -->
                <template #number="{ record }">
                  <a-input placeholder="商品编号" :value="record.sku_sn" v-model:value="record.sku_sn" :disabled="$route.query.type == 'edit'" :maxlength="20" />
                </template>
                <!-- <template #actions="{ record }">
                  <a-button type="link" @click="allset(record)" class='m-r-20'>
                    批量设置
                  </a-button>
                </template> -->
              </a-table>
              <div v-if="specGridCell&&specGridCell.length&&$route.query.type != 'edit'" class='m-t-10'>
                <a-popconfirm @confirm="confirmSetPrice" @cancel="SetPrice=0" class='m-r-10'>
                  <template #title>
                    <a-input-number placeholder="产品价格" :value="SetPrice" v-model:value="SetPrice"  />
                  </template>
                  <template #icon>
                    <span></span>
                  </template>
                  <a-button>
                    <PlusOutlined /> 批量设置价格
                  </a-button>
                </a-popconfirm>
                <!-- <a-popconfirm @confirm="confirmSetStock" @cancel="SetStockNum=0">
                  <template #title>
                    <a-input-number placeholder="产品库存" :value="SetStockNum" v-model:value="SetStockNum" v-inputFilter:Int />
                  </template>
                  <template #icon>
                    <span></span>
                  </template>
                  <a-button>
                    <PlusOutlined /> 批量设置库存
                  </a-button>
                </a-popconfirm> -->
              </div>
            </template>
          </a-form-item>
          <!--产品规格结束-->
          <a-form-item ref="product_price" label="价格" name="product_price" :rules="[{ required: $route.query.type == 'edit'||spec_type?false:true, message: '请输入价格' }]">
            <a-input v-model:value="form.product_price" :disabled="spec_type" prefix="￥" suffix="RMB" :min="0" type="number" placeholder="请输入价格" />
          </a-form-item>
          <a-form-item ref="product_sales" label="虚拟销量" name="product_sales">
            <a-input v-model:value="form.product_sales" placeholder="虚拟销量" :disabled="spec_type" />
          </a-form-item>
          <a-form-item ref="product_sn" label="商品编号" name="product_sn" help='（仅支持数字、字母及英文"-"）限制20字符' :rules="[{ required:true, message: '请输入商品编号' }]">
            <a-input v-model:value="form.product_sn" placeholder="请输入商品编号" v-inputFilter:sn :disabled="$route.query.type == 'edit'" :maxlength="20" />
          </a-form-item>
          <a-form-item ref="market_price" label="市场定价" name="market_price" help="（吊牌价）">
            <a-input v-model:value="form.market_price" v-inputFilter:price prefix="￥" suffix="RMB" type="number" :min="0" placeholder="请输入市场定价" />
          </a-form-item>
          <a-form-item ref="sort" label="列表排序" name="sort">
            <a-input v-model:value="form.sort" placeholder="列表排序" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
            <a-button type="primary" @click="()=>{$router.go(-1)}" class='m-r-10'> 取消 </a-button>
            <a-button type="primary" @click="next()"> 下一步 </a-button>
          </a-form-item>
        </div>
        <div class="editorContent" v-show="current == 1">
          <app-warp title="商品详情">
            <template #app-content>
              <div class="app-content" v-html="form.content">
              </div>
            </template>
            <template #app-sider>
              <div style="width:80%;margin-left:70px">
                <quill v-model:value="form.content" :content="JSON.parse(JSON.stringify(form.content))" :height="700" style="height:1000px" />
              </div>
            </template>
          </app-warp>
        </div>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" v-show="current == 1">
          <a-button type="primary" @click="current--" class='m-r-10'> 上一步 </a-button>
          <a-button type="primary" @click="onSubmit()" v-if="$route.query.type != 'look'"> 提交 </a-button>
          <a-button type="primary" @click="$router.push('/product/libs/management/index')" v-else> 返回 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import {
  MinusCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
  // EditOutlined,
} from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import {
  getProductCate,
  getCategoryList,
  createProduct,
  createProductSpec,
  getProductDetail,
  editProduct,
} from "@/api/product.js";
import { iscode } from "@/utils/app";
import store from "@/store";
import { isArray } from "lodash";
// 初始化默认筛选项数值
let defForm = {
  video_is_show:0,
  product_name: "",
  name: "",
  time: [],
  product_category_id: [],
  product_price: "",
  market_price: "",
  breif: "",
  stock: "",
  product_sn: "",
  unit: "",
  bar_Code: "",
  product_sales: "",
  product_weight: "",
  point_gift: "",
  sort: "",
  content: "",
  parameter: [],
  image_url: [],
  product_category_type_id: null,
  spec_many: {},
};

export default {
  components: {
    MinusCircleOutlined,
    DeleteOutlined /*EditOutlined*/,
    PlusOutlined,
  },
  setup() {
    //pass
    const form = ref(JSON.parse(JSON.stringify({ ...defForm })));
    const state = reactive({
      info: store.state.user.info,
      typeLoading: false,
      SetStockNum: 0,
      SetPrice: 0,
      current: 0,
      content: "",
      spec_type: false,
      steps: [
        {
          title: "编辑基本信息",
        },
        {
          title: "编辑图文详情",
        },
      ],
      skusValidateForm: {
        skus: [],
      },
      CategoryList: [], //类目列表
      cateList: [], //分类列表
      dataSource: [],
      targetKeys: [],
      fileList: [],
      loading: false,
      imageUrl: "",
      previewVisible: false,
      previewImage: "",
      labelCol: { span: 3 },
      wrapperCol: { span: 9 },
      rules: {
        name: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
        product_category_type_id: {},
      },
      columns: [],
      basecolumns: [
        //   {
        //   title: "规格名",
        //   dataIndex: "spec_name",
        //  customRender: ({ text, index }) => {
        //         const obj = {
        //           children: text,
        //           props: {},
        //         };
        //         if (index === 1) {
        //           obj.props.rowSpan = 2;
        //         }
        //         return obj;
        //       },
        // },
        // {
        //   title: "规格",
        //   dataIndex: "spec_value",
        //    slots: { customRender: "name" },
        // },

        {
          title: "规格图片",
          dataIndex: "imageUrl",
          slots: { customRender: "imageUrl" },
        },
        {
          title: "价格(元)",
          dataIndex: "productPrice",
          slots: { customRender: "productPrice" },
        },
        {
          title: "虚拟销量",
          dataIndex: "productSales",
          slots: { customRender: "productSales" },
        },
        {
          title: "商品编号",
          dataIndex: "number",
          slots: { customRender: "number" },
        },
        // {
        //   title: "操作",
        //   dataIndex: "actions",
        //   slots: { customRender: "actions" },
        // },
      ],
    });
    const ruleForm = ref();
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    // 初始化
    const init = async () => {
      // 获取分类列表
      let result = await getProductCate().then((res) => res.data);
      //
      // result.data.map((v) => (v.disabled = !v.child ? true : false));
      let cateItem = {
        group_name: "暂不分类",
        id: 0,
      };
      result.data.unshift(cateItem);
      state.cateList = result.data;
      // 获取类目列表
      state.typeLoading = true;
      let Category = await getCategoryList().then((res) => res.data);
      if (iscode(Category)) {
        state.CategoryList = Category.data;
        state.typeLoading = false;
      } else {
        message.error(Category.msg);
        state.typeLoading = false;
      }

      // 获取页面参数
      if ($route.query.id) {
        // 获取详情
        getProductDetail($route.query.id).then((res) => {
          var result = res.data.data;
          state.spec_type = result.spec_type == 2 ? true : false;
          form.value = result;
          result.parameter.forEach((v, k) => {
            form.value.parameter[k][0] = v.name;
            form.value.parameter[k][1] = v.value;
          });
          form.value.content = result.content.content;
          var image_url = [];
          result.image.forEach((v, k) => {
            image_url[k] = v.image_url;
          });
          form.value.image_url = image_url;
          var product_category_id = [];
          state.cateList.forEach((v) => {
            if (v.id == result.product_category_id) {
              product_category_id.push(v.id);
            }
            if (v.child) {
              v.child.forEach((e) => {
                if (e.id == result.product_category_id) {
                  product_category_id = [v.id, e.id];
                }
              });
            }
          });
          form.value.product_category_id = product_category_id;

          if (result.specValue) {
            specGridCell.value = result.sku;
            skus.value = JSON.parse(result.specValue.skus);
            cretateSpace(true);
          }
        });
      }
    };
    init();
    // 添加参数
    const parameterKey = ref();
    const parameterValue = ref();
    const onParameterCreate = () => {
      if (parameterKey.value && parameterValue) {
        if (form.value.parameter.length == 50) {
          message.error("产品参数最多50个");
          return;
        }
        form.value.parameter.push([parameterKey.value, parameterValue.value]);
        parameterKey.value = "";
        parameterValue.value = "";
      } else {
        message.error("请输入参数");
      }
    };
    // 删除参数
    const skus = ref([]); //存放添加规格的表单
    const spec_many = ref(); //规格提交的数据、
    const addParameter = () => {
      if (skus.value.length >= 3) {
        message.error("规格最多输入3种");
        return;
      }
      skus.value.push({
        spec_value: [],
        spec_name: "",
        value: "",
      });
    };
    // 删除规格
    const removesku = (index) => {
      skus.value.splice(index, 1);
    };
    // 追加规格值
    const addSku = async (k) => {
      if (skus.value[k].spec_value.length == 5) {
        message.error("属性最多输入5种");
        return;
      }
      if (!skus.value[k].value || !skus.value[k].spec_name) {
        message.error("请输入完整");
        return;
      }
      skus.value[k].spec_value.push({ name: skus.value[k].value });
      skus.value[k].value = "";
    };
    // 清除规格中的某个值
    const removeskuvalue = (key, index) => {
      skus.value[key].spec_value.splice(index, 1);
    };
    // 生成属性
    const specGridCell = ref();
    const cretateSpace = (is_detail) => {
      var spec_many = {
        spec_attr: "",
        spec_list: [],
      };
      // 过滤空白的规格
      let normlizeList = skus.value.map((item) => {
        return {
          spec_name: item.spec_name,
          spec_value: item.spec_value.filter((value) => value.name),
        };
      });
      // 获取规格数据
      if (is_detail) {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            product_price: specGridCell.value[key].product_price,
            market_price: specGridCell.value[key].market_price,
            stock_num: specGridCell.value[key].stock_num,
            product_sales: specGridCell.value[key].product_sales,
            product_weight: specGridCell.value[key].product_weight,
            image_url: specGridCell.value[key].image_url,
            sku_sn: specGridCell.value[key].sku_sn,
          };
        });
      } else {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            product_price: 0,
            market_price: 0,
            stock_num: 0,
            product_sales: 0,
            product_weight: 0,
            image_url: "",
            sku_sn: "",
          };
        });
      }
      // 整理数据
      specGridCell.value.forEach((v, key) => {
        if (v.propertyList.length) {
          v.propertyList.forEach((element, index) => {
            v["text" + index] = element.value;
          });
        }
      });
      // 动态生成表头
      var columns = [];
      normlizeList.forEach((element, key) => {
        columns.push({
          title: element.spec_name,
          dataIndex: "text" + key,
          key: "text" + key,
          customRender: ({ text }) => {
            const obj = {
              children: text,
            };
            return obj;
          },
        });
      });
      state.columns = columns.concat(state.basecolumns);
    };
    // 处理多规格数据
    const spaceHandle = (arr) => {
      function mix(item1, item2) {
        var arr1 = Array.isArray(item1.spec_value) ? item1.spec_value : item1;
        var arr2 = item2.spec_value;
        var result = [];
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            let item = [];
            if (Array.isArray(arr1[i])) {
              item = item.concat(arr1[i]);
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            } else {
              item.push({
                name: item1.spec_name,
                value: arr1[i].name,
              });
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            }
            result.push(item);
          }
        }
        return result;
      }
      if (arr.length < 1) {
        return [];
      } else if (arr.length < 2) {
        let result = [];
        let item = arr[0];
        item.spec_value.map((value) => {
          result.push([
            {
              name: item.spec_name,
              value: value.name,
            },
          ]);
        });
        return result;
      } else {
        return arr.reduce((acc, item) => {
          return mix(acc, item);
        });
      }
    };
    // 批量设置价格
    const confirmSetPrice = () => {
      specGridCell.value.forEach((v) => {
        v["product_price"] = state.SetPrice;
      });
    };
    // 批量设置库存
    const confirmSetStock = () => {
      specGridCell.value.forEach((v) => {
        v["stock_num"] = state.SetStockNum;
      });
    };
    const allset = (data) => {
      specGridCell.value.forEach((v) => {
        v["product_price"] = data["product_price"];
        v["market_price"] = data["market_price"];
        v["stock_num"] = data["stock_num"];
        v["product_weight"] = data["product_weight"];
        v["image_url"] = data["image_url"];
        v["product_sales"] = data["product_sales"];
        v["sku_sn"] = data["sku_sn"];
      });
    };
    // 下一步
    const next = (step) => {
      // 第一步的校验
      if (step && step == 1) {
        // if (form.value.product_category_type_id == null) {
        //   message.error("请选择类目");
        //   return;
        // }
        state.current++;
      } else {
        ruleForm.value
          .validate()
          .then((res) => {
            if (state.spec_type) {
              // 检测是否需要生成 规格表单
              var flag = false;
              if (!isArray(specGridCell.value)) {
                cretateSpace(false);
                flag = "请完善商品规格信息";
              }
              specGridCell.value.forEach((element) => {
                for (const key in element) {
                  if (key == "image_url" && !element[key]) {
                    flag = "请完善商品图片";
                  }
                  if (key == "sku_sn" && !element[key]) {
                    flag = "请完善商品编号";
                  }
                  if (key == "product_price" && !element[key]) {
                    flag = "请完善商品价格";
                  }
                  //  if(key=='stock_num' && !element[key]){
                  //   flag='请完善商品库存'
                  // }
                }
              });

              if (!flag) {
                state.current++;
              } else {
                message.error(flag);
              }
            } else {
              state.current++;
            }
          })
          .catch((error) => {
            console.log(error);
            message.error("请完善表单");
          });
      }
    };
    const router = inject("$router");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          if (state.spec_type) {
            // 多规格
          }
          var result;
          let json = {
            ...e,
            content: form.value.content,
            product_category_id:
              e.product_category_id[e.product_category_id.length - 1],
            spec_many: JSON.stringify(specGridCell.value),
            skus: JSON.stringify(skus.value),
            spec_type: state.spec_type ? 2 : 1,
            video_cover_image_url:form.value.video_cover_image_url,
            video_image_url:form.value.video_image_url,
            video_url:form.value.video_url

          };
          if ($route.query.id) {
            result = await editProduct($route.query.id, json).then(
              (res) => res.data
            );
          } else {
            result = await createProduct(json).then((res) => res.data);
          }
          if (iscode(result, true)) {
            router.push({ path: "/product/libs/management/index" });
            setTimeout(() => {
              ruleForm.value.resetFields();
              form.value = {};
            }, 100);
          }
        })
        .catch((error) => {
          state.current--;
        });
    };
    // 切换 规格
    const changeSkuType = () => {
      form.value.product_price = "";
      form.value.product_sales = "";
      form.value.product_sn = "";
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      next,
      addParameter,
      removesku,
      skus,
      addSku,
      allset,
      spec_many,
      parameterKey,
      cretateSpace,
      removeskuvalue,
      parameterValue,
      onParameterCreate,
      specGridCell,
      confirmSetPrice,
      confirmSetStock,
      changeSkuType,
    };
  },
};
</script>
<style lang="less" >
@import url("@/style/app-warp/app-warp.less");
</style>
<style lang="less" scoped>
.ant-row {
  margin-bottom: 40px;
}

.editorContent {
  display: flex;
  .detailContent {
    background-image: url("../../../../assets/images/iphone.png");
    width: 327px;
    height: 727px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 50px;
    word-break: break-all;
    padding: 50px 23px 10px;
  }
}

.cateItem {
  width: 195px;
  height: 73px;
  text-align: center;
  line-height: 73px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  margin-right: 26px;

  > label {
    width: 195px;
    height: 73px;
    display: block;
    position: relative;
    box-shadow: 0px 0px 22px 0px #dbe7f3;
    border-radius: 5px;
    overflow: hidden;
  }

  .current {
    display: none;
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    pointer-events: none;
    border: 20px solid #83c8dd;
    border-left-color: transparent;
    border-top-color: transparent;
    right: -1px;
    bottom: -1px;

    span {
      position: absolute;
      font-size: 14px;
      color: #fff;
      margin-top: 8px;
      transform: rotate(10deg);
    }
  }

  input:checked ~ label {
    .current {
      display: block;
    }
  }
}

.otherItem {
  position: relative;
  box-shadow: 0px 0px 22px 0px #dbe7f3;
  border-radius: 5px;
  .otherList {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    display: none;
    position: absolute;
    border-top: none;
    width: 287px;
    overflow: scroll;
    height: 100px;
    right: -1px;
    top: 79px;
    box-sizing: border-box;
    transition: display 1s;
    &::before {
      content: "";
      width: 92px;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .ant-radio-group {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  &:hover {
    border-bottom: none;
    height: 80px;
    .otherList {
      display: block;
      box-shadow: 0px 0px 22px 0px #dbe7f3;
    }
  }
}
</style>
